import * as THREE from "three";
import React, { useMemo, useState } from "react";

import { params } from "../../../../../../redux/reducers/reducer";
import { extrudeSettings, leanRoofLoftTrimModel } from "../../../../../../utils/Functions";
import { MaterialTrim } from '../../../../CustomMaterial';

const TrimModel = () => {
    const [isEqualHeight, setIsEqualHeight] = useState(false);
    const [isEqualFrontLeanHeight, setIsEqualFrontLeanHeight] = useState(false);
    const [isEqualBackLeanHeight, setIsEqualBackLeanHeight] = useState(false);
    const [overHangLength, setOverHangLength] = useState(0);

    const trimThickness = (params.p_r_s === 1) ? 0.2 : 0.1;
    const cbFrontBackWallOffset = 0.16;

    const leanRoofHeight = (params.b_l_t_r_p / 12) * params.lean_p_w;
    const leanRoofLeftHeight = params.b_l_t_r_pF / 12 * params.leanF_p_w;
    const leanRoofRightHeight = params.b_l_t_r_pB / 12 * params.leanB_p_w;

    const trimOffsetHeight = (params.p_r_p / 12) * 0.2;

    const leftOffsetValue = useMemo(() => (
        (isEqualFrontLeanHeight && !isEqualBackLeanHeight && !isEqualHeight && (params.p_d === params.lean_p_d || Number(params.leantoAlignmentLeft) === 2)) ||
        (isEqualFrontLeanHeight && isEqualBackLeanHeight && !isEqualHeight && (params.p_d !== params.lean_p_d && Number(params.leantoAlignmentLeft) === 2)) ||
        (isEqualFrontLeanHeight && isEqualBackLeanHeight && !isEqualHeight && (params.p_d === params.lean_p_d))
      ) ? 0.52 : 0, [isEqualFrontLeanHeight, isEqualBackLeanHeight, isEqualHeight, params.p_d, params.lean_p_d, params.leantoAlignmentLeft]);
      
      const rightOffsetValue = useMemo(() => (
        (!isEqualFrontLeanHeight && isEqualBackLeanHeight && !isEqualHeight && (params.p_d === params.lean_p_d || Number(params.leantoAlignmentLeft) === 3)) ||
        (isEqualFrontLeanHeight && isEqualBackLeanHeight && !isEqualHeight && (params.p_d !== params.lean_p_d && Number(params.leantoAlignmentLeft) === 3)) ||
        (isEqualFrontLeanHeight && isEqualBackLeanHeight && !isEqualHeight && (params.p_d === params.lean_p_d))
      ) ? 0.52 : 0, [isEqualFrontLeanHeight, isEqualBackLeanHeight, isEqualHeight, params.p_d, params.lean_p_d, params.leantoAlignmentLeft]);

    const roofSideTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-0.07, (-0.07 * params.b_l_t_r_p) / 12);
        model.lineTo(
            params.lean_p_w - (isEqualHeight && 0.2),
            (params.b_l_t_r_p / 12) * params.lean_p_w - (isEqualHeight && trimOffsetHeight)
        );
        model.lineTo(
            params.lean_p_w - (isEqualHeight && 0.2),
            (params.b_l_t_r_p / 12) * params.lean_p_w - (isEqualHeight && trimOffsetHeight) - 0.2
        );
        model.lineTo(-0.07, (-0.07 * params.b_l_t_r_p) / 12 - 0.2);
        model.closePath();

        return model;
    }, [isEqualHeight, params.b_l_t_r_p, params.lean_p_w, trimOffsetHeight]);

    const roofFrontTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        model.moveTo(-0.02, (-params.b_l_t_r_p / 12) * 0.02);
        model.lineTo(0.05, (params.b_l_t_r_p / 12) * 0.1);
        model.lineTo(0.05, (params.b_l_t_r_p / 12) * 0.1 - 0.2);
        model.lineTo(-0.02, (-params.b_l_t_r_p / 12) * 0.02 - 0.2);
        model.closePath();

        return model;
    }, [params.b_l_t_r_p]);

    const trimLength = useMemo(() => {
        let length;

        if (params.add_left_front_lean_porch !== true && params.add_left_back_lean_porch !== true) {
            length = params.lean_p_d + cbFrontBackWallOffset * 2 + 0.04;
        } else if (
            (params.add_left_front_lean_porch !== true && params.add_left_back_lean_porch === true) ||
            (params.add_left_front_lean_porch === true && params.add_left_back_lean_porch !== true)
        ) {
            length = params.lean_p_d + params.lean_p_w + cbFrontBackWallOffset * 2 + 0.04;
        } else {
            length = params.lean_p_d + 2 * params.lean_p_w + cbFrontBackWallOffset * 2 + 0.04;
        }
        return length;
    }, [params.add_left_front_lean_porch, params.add_left_back_lean_porch, params.lean_p_d, params.lean_p_w]);

    const position = useMemo(() => {
        if (params.add_left_front_lean_porch === true && params.add_left_back_lean_porch === true) {
            return -trimLength / 2;
        } else if (params.add_left_front_lean_porch === true && params.add_left_back_lean_porch !== true) {
            return -trimLength / 2 + params.lean_p_w / 2;
        } else if (params.add_left_front_lean_porch !== true && params.add_left_back_lean_porch === true) {
            return -trimLength / 2 - params.lean_p_w / 2;
        } else {
            return -trimLength / 2;
        }
    }, [params.add_left_front_lean_porch, params.add_left_back_lean_porch, params.lean_p_w, trimLength])
    
    
    useMemo(() => {
        if (params.p_h === leanRoofHeight + params.lean_p_h) {
            setIsEqualHeight(true);
        } else {
            setIsEqualHeight(false);
        }
        if(params.add_front_lean && (leanRoofHeight + params.lean_p_h === leanRoofLeftHeight + params.leanF_p_h) && ((params.p_w === params.leanF_p_d) || Number(params.leantoAlignmentFront) === 2))
            setIsEqualFrontLeanHeight(true);
        else setIsEqualFrontLeanHeight(false)
        if(params.add_back_lean && (leanRoofHeight + params.lean_p_h === leanRoofRightHeight + params.leanB_p_h) && ((params.p_w === params.leanB_p_d) || Number(params.leantoAlignmentBack) === 3))
            setIsEqualBackLeanHeight(true);
        else setIsEqualBackLeanHeight(false)
       }, [params.p_h, params.lean_p_h, params.b_l_t_r_p, leanRoofHeight, leanRoofLeftHeight, leanRoofRightHeight, params.add_front_lean, params.add_back_lean, params.leanB_p_d, params.leanF_p_d, params.p_w, params.leantoAlignmentFront, params.leantoAlignmentBack, params.leanF_p_h, params.leanB_p_h])

    useMemo(() => {

        if (params.p_r_s === 2 || params.p_r_s === 1) {
            if(params.p_r_s === 2) setOverHangLength(0.75); else setOverHangLength(0.75);

        } else if (params.p_r_s === 3) {

            if (params.o_v_h_n_g_e === true) {
                setOverHangLength(0.9)
            } else {
                setOverHangLength(0.75)
            }
        }
    }, [params.p_r_s, params.o_v_h_n_g_e])

    return (
        <group>
            { !params.add_left_back_lean_porch && 
                ( params.p_r_s === 1 ?
                    <mesh name='loft-roof-trim-left' position={[-(params.p_w / 2 + params.lean_p_w + 0.07), params.lean_p_h - 0.05 , -(params.lean_p_d / 2 + 0.01 + overHangLength) + rightOffsetValue]} rotation={[0, 0, 0]}>
                        <extrudeGeometry args={[leanRoofLoftTrimModel(params.b_l_t_r_p, params.lean_p_w + 0.1), extrudeSettings(trimThickness)]} />
                        <MaterialTrim visibleSection={"leftLean"} />
                    </mesh>
                    :
                    <mesh name='non-loft-roof-trim-left' position={[-(params.p_w / 2 + params.lean_p_w), params.lean_p_h, -(params.lean_p_d / 2 + 0.14)]} rotation={[0, 0, 0]}>
                        <extrudeGeometry args={[roofSideTrimModel, extrudeSettings(-trimThickness)]} />
                        <MaterialTrim visibleSection={"leftLean"} />
                    </mesh>
                )
            }
            { !params.add_left_front_lean_porch &&
                ( params.p_r_s === 1 ? 
                    <mesh name='loft-roof-trim-right' position={[-(params.p_w / 2 + params.lean_p_w + 0.07), params.lean_p_h - 0.05, (params.lean_p_d / 2 + overHangLength + 0.01 - trimThickness) - leftOffsetValue]} rotation={[0, 0, 0]}>
                        <extrudeGeometry args={[leanRoofLoftTrimModel(params.b_l_t_r_p, params.lean_p_w + 0.1), extrudeSettings(trimThickness)]} />
                        <MaterialTrim visibleSection={"leftLean"} />
                    </mesh>
                    :
                    <mesh name='non-loft-roof-trim-right' position={[-(params.p_w / 2 + params.lean_p_w), params.lean_p_h, params.lean_p_d / 2 + 0.14]} rotation={[0, 0, 0]}>
                        <extrudeGeometry args={[roofSideTrimModel, extrudeSettings(trimThickness)]} />
                        <MaterialTrim visibleSection={"leftLean"} />
                    </mesh>
                )
            }
            { params.p_r_s !== 1 && (
                <mesh name='non-loft-roof-trim-front' position={[-(params.p_w / 2 + params.lean_p_w + 0.05), params.lean_p_h - 0.05 * (params.b_l_t_r_p / 12), position]} rotation={[0, 0, 0]}>
                    <extrudeGeometry args={[roofFrontTrimModel, extrudeSettings(trimLength)]} />
                    <MaterialTrim visibleSection={"leftLean"} />
                </mesh>
            )}
        </group>
    );
};

export default TrimModel;
